import { apiClient } from "./api-client";

/** @param {{ q: string; items_per_page?: number; start_index?: number }} params */
export async function searchUkCompanies({ q, items_per_page = 10, start_index = 0 }) {
  const data = await apiClient({
    url: "users/uk-companies/search",
    method: "GET",
    params: { q, items_per_page, start_index }
  });
  if (data?.status !== "success" || !Array.isArray(data?.data?.items)) {
    return [];
  }
  return data.data.items;
}
